import axiosInstance from "../api/axiosInstance";

// Latest UI discovery run id per project: { [projectId]: discovery_run_id }
const STORAGE_KEY = "discoveryRunIds";

const readRunIds = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) || {} : {};
  } catch (error) {
    console.error("Error reading discovery run ids from localStorage:", error);
    return {};
  }
};

const writeRunIds = (runIds) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(runIds));
  } catch (error) {
    console.error("Error saving discovery run ids to localStorage:", error);
  }
};

export const getStoredDiscoveryRunId = (projectId) => {
  if (!projectId) return null;
  return readRunIds()[projectId] || null;
};

/**
 * Fetches the latest discovery run of a project and caches its id in localStorage.
 * Resolves to null when the project has not been crawled yet.
 */
export const fetchLatestDiscoveryRunId = async (projectId) => {
  if (!projectId) return null;

  const response = await axiosInstance.get("/crawler/run_id/list", {
    params: { project_id: projectId, latest_only: true },
  });
  const runId = response?.data?.discovery_run_id || null;

  const runIds = readRunIds();
  if (runId) {
    runIds[projectId] = runId;
  } else {
    delete runIds[projectId];
  }
  writeRunIds(runIds);

  return runId;
};
